import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const inputStyles = cva(
  'flex h-10 w-full rounded-md border px-3 py-2 text-base !outline-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
  {
    variants: {
      variant: {
        light:
          'border-neutral-500 bg-white ring-offset-white file:text-slate-950 placeholder:text-slate-500 focus-visible:border-jb-primary-500',
        dark: 'border-slate-800 bg-slate-950 ring-offset-slate-950 file:text-slate-50 placeholder:text-slate-400 focus-visible:ring-slate-300',
      },
    },
    defaultVariants: {
      variant: 'light',
    },
  }
);

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & VariantProps<typeof inputStyles>
>(({ className, type, variant, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputStyles({ variant }), className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
